<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">{{propItem ? "Edit Item" : "Add Item"}}</p>
    </header>

    <section class="modal-card-body">
      <b-field label="Name:">
        <b-input :disabled="role === 'viewer'" type="text" v-model="name" placeholder="Item Name"></b-input>
      </b-field>

      <b-field v-if="bNameError" style="color: red">
        Please enter a name.
      </b-field>

      <b-field label="Description:">
        <b-input :disabled="role === 'viewer'" type="text" v-model="description" placeholder="Item Description"></b-input>
      </b-field>

      <!-- <b-field label="Item Type:">
        <b-select v-model="type">
          <option v-for="type of typeList" :value="type.toLowerCase()" :key="type">{{type}}</option>
        </b-select>
      </b-field> -->

<b-field v-if="type !== 'airquality' && type !== 'url'" label="Item Type:">
        {{type.charAt(0).toUpperCase() + type.slice(1)}}
      </b-field>
      <b-field v-else-if="type === 'airquality'" label="Item Type:">
        Air Quality
      </b-field>
      <b-field v-else label="Item Type:">
        URL
      </b-field>

      <div v-if="type === 'url' || type === 'youtube'">
        <b-field label="URL:" :message="type === 'url' ? 'Valid format: (http://www.example.com)' : 'Insert video tag (ex: https://www.youtube.com/watch?v=<b>rFfomw-Z4uE</b>)'">
          <b-input :disabled="role === 'viewer'" type="text" v-model="url" placeholder="Item URL"></b-input>
        </b-field>
        <b-field v-if="bURLError" style="color: red">
         Please enter a URL.
      </b-field>
      </div>

      <div v-if="type === 'airquality'">
        <b-field label="Air Quality Type:">
          <b-select :disabled="role === 'viewer'" v-model="pollutionType">
            <option v-for="type1 of pollutionTypes" :value="type1.toLowerCase()" :key="type1">{{type1}}</option>
          </b-select>
        </b-field>
      </div>

      <div v-if="type === 'rates'">
        <b-field label="Source:">
          <b-select :disabled="role === 'viewer'" v-model="ratesSource">
            <option value="nbrm">Sparkasse</option>
          </b-select>
        </b-field>
      </div>

      <div v-if="type === 'weather'">
        <b-field label="City:">
          <b-select :disabled="role === 'viewer'" v-model="weatherCity">
              <option v-for="city of weatherCities" :key="city.id" :value="city.id">{{city.name}}</option>
          </b-select>
        </b-field>
      </div>

      <div v-if="!(type === 'video' || type === 'youtube')">
        <b-field label="Duration (seconds):">
          <b-numberinput :disabled="role === 'viewer'" type="is-info" controls-position="compact" controls-rounded v-model="duration" min="10"></b-numberinput>
        </b-field>
      </div>

      <div v-if="type === 'arrivals' || type === 'departures'">
        <b-field label="Airport:">
          <b-select :disabled="role === 'viewer'" v-model="airportCode">
            <option value="skp">Skopje (SKP)</option>
            <option value="ohd">Ohrid (OHD)</option>
          </b-select>
        </b-field>
      </div>

      <b-field v-if="!(type === 'url' || type === 'youtube')" :label="type === 'video' ? 'Choose video to upload' : (type === 'pdf' ? 'Choose PDF to upload' : 'Choose image to upload')">
        <!-- <b-button icon-left="file-upload" type="is-info" @click="addFile()">
          {{getButtonText()}}
        </b-button> -->
      </b-field>
<div v-if="!(type === 'url' || type === 'youtube')">
        <b-button :disabled="role === 'viewer'" icon-left="file-upload" type="is-primary" outlined @click="addFile()">
          Local storage
        </b-button>
        <b-button :disabled="role === 'viewer'" icon-left="file" type="is-success" outlined @click="type === 'video' ? openVideoLibrary() : (type === 'pdf' ? openPdfLibrary() : openImageLibrary())">
          Existing resources
        </b-button>
        <b-button :disabled="role === 'viewer'" icon-left="trash" type="is-danger" outlined @click="type === 'video' ? openBin('video') : (type === 'pdf' ? openBin('pdf') : openBin('image'))">
    {{type === 'video' ? 'Playlists videos archive' : (type === 'pdf' ? 'Playlists PDFs archive' : 'Playlists images archive') }}
    </b-button>
</div>
      <!-- <b-field v-if="!(type === 'url' || type === 'youtube')">
        <b-button icon-left="file-upload" type="is-info" @click="type === 'video' ? openVideoLibrary() : openImageLibrary()">
          From library
        </b-button>
      </b-field> -->

      <b-field v-if="resourceName.length > 0 && imageUrl.length > 0">
        <div><b>Currently uploaded file:</b> {{resourceName}}</div>
        <div v-if="type === 'arrivals' || type === 'departures' || type === 'clock' || type === 'weather' || type === 'airquality' || type === 'rates'">
          <b-button :disabled="role === 'viewer'" style="margin-left:5px" icon-left="times" size="is-small" type="is-danger" @click="removeBackgroundImage()"></b-button>
        </div>
      </b-field>

      <b-field v-if="resourceName.length > 0 && pdfUrl.length > 0">
        <div><b>Currently uploaded file:</b> {{resourceName}}</div>
      </b-field>

      <b-modal :active.sync="isImageModalActive" scroll="keep">
        <p class="image">
          <img :src="imageUrl" >
        </p>
      </b-modal>

      <b-field v-if="resourceName.length > 0 && imageUrl.length > 0 && videoUrl===''">
        <img :src="imageUrl" width="275" @click="isImageModalActive=true" style="cursor:pointer">
      </b-field>

      <b-field v-if="resourceName.length > 0 && pdfUrl.length > 0 && videoUrl===''">
          <!--<embed
          :src="pdfUrl"
    type="application/pdf"
    frameBorder="0"
    scrolling="auto"
    height="50%"
    width="50%"
>-->
<iframe
    :src="pdfUrl"
    frameBorder="0"
    scrolling="auto"
    height="50%"
    width="50%"
></iframe>

<a :href="pdfUrl" target="_blank" style="width:27px;height:27px;padding-left: 5px"><img src="@/assets/newtab1.png"/></a>
      </b-field>

      <b-field v-if="resourceName.length > 0 && videoUrl!==''">
<my-video class="__cov-video" :sources="[{
          src: this.videoUrl,
          type: 'video/mp4'
        }]" :options="video.options"></my-video>
</b-field>
      <!-- <vue-player v-if="videoUrl!=''" :src="videoUrl" poster="/static/images/blackk.jpg" :title="resourceName"></vue-player> -->

      <b-field v-if="itemFiles[0]">
        Chosen file for upload: {{itemFiles[0].name}}
      </b-field>

      <b-field v-if="bFileError" style="color: red">
        {{bFileMessage}}
      </b-field>

      <b-field label="Entry Effect:">
        <b-select :disabled="role === 'viewer'" v-model="entryEffect" @input="debugEffectLog()">
          <option v-for="(effect, id) of entryEffects" :key="id" :value="id">{{effect}}</option>
        </b-select>
      </b-field>

      <b-field label="Exit Effect:">
          <b-select :disabled="role === 'viewer'" v-model="exitEffect" @input="debugEffectLog()">
            <option v-for="(effect, id) of exitEffects" :key="id" :value="id">{{effect}}</option>
          </b-select>
      </b-field>

    </section>

    <footer class="modal-card-foot">
      <b-button type="is-info" @click="submitItem" :disabled="role === 'viewer'">Save</b-button>
      <b-button type="is-light" @click="$parent.close()">Cancel</b-button>
      <input style="display: none" @change="fileUploaded" id="fileSelect" name="fileSelect" type="file">
    </footer>
  </div>
</template>

<script>
import * as service from '@/components/playlists/playlistService'
// import vuePlayer from '@algoz098/vue-player'
import myVideo from 'vue-video'
import PhotosLibrary from '@/components/playlists/items/PhotosLibrary'
import VideosLibrary from '@/components/playlists/items/VideosLibrary'
import PdfsLibrary from '@/components/playlists/items/PdfsLibrary'
import PlaylistsBin from '@/components/playlists/items/PlaylistsBin'

export default {
  name: 'ItemAddEdit',
  props: ['propType', 'propItem', 'propId', 'propParentFn', 'playlId'],
  /* components: {
    vuePlayer
  }, */
  components: {
    myVideo
  },
  data: () => {
    return {
      typeList: ['Image', 'Video', 'URL', 'Arrivals', 'Departures', 'Clock', 'Youtube', 'Weather', 'AirQuality', 'PDF'],
      name: '',
      description: '',
      duration: 10,
      type: '',
      url: '',
      imageUrl: '',
      resourceName: '',
      resourceSize: null,
      pollutionType: '',
      ratesSource: 'nbrm',
      weatherCity: '',
      airportCode: 'skp',
      itemFiles: [],
      entryEffects: service.entryEffectValues,
      entryEffect: 8,
      exitEffects: service.exitEffectValues,
      exitEffect: 8,
      bFileError: false,
      bNameError: false,
      bURLError: false,
      bFileMessage: '',
      isImageModalActive: false,
      removingBcg: false,
      bcgIsUsed: false,
      oldBcgResName: '',
      oldBckResSize: 0,
      videoUrl: '',
      video: {
        // sources: ,
        options: {
          autoplay: false,
          volume: 0.6
          // poster: '/static/images/blackk.jpg'
        }
      },
      toRemove: [],
      toArchive: [],
      playlistRef: {},
      items: [],
      deleteFromBinItem: null,
      sizeOfResource: 0,
      nameOfResource: null,
      sizeMinus: null,
      airQuality: null,
      oldItem: null,
      alreadyUploadedFile: null,
      newUpload: false,
      pdfUrl: ''
    }
  },
  mounted: function () {
    // this.airQuality = ['PM10', 'PM25', 'NO2', 'SO2', 'O3']
    this.globalLogger('bcg: ', this.removingBcg)
    if (this.playlId !== undefined) {
      this.playlistRef = Object.assign({}, this.$store.getters.getPlaylist(this.playlId))
      if (this.playlistRef.items) {
        this.items = [...this.playlistRef.items.filter(x => x)]
      }
    }
    this.weatherCity = this.weatherCities[0].id
    this.pollutionType = this.pollutionTypes[0].toString().toLowerCase()
    if (this.propType) {
      this.type = this.propType
    }
    if (this.propItem) {
      this.oldItem = Object.assign({}, this.propItem)
      this.globalLogger(this.oldItem, 'OLD ITEM na pocetok')
      this.name = this.propItem.name
      this.description = this.propItem.description
      this.type = this.propItem.type
      this.entryEffect = parseInt(this.propItem.effect / 10)
      this.exitEffect = this.propItem.effect % 10
      if (this.propItem.file) {
        this.itemFiles = [this.propItem.file]
        this.alreadyUploadedFile = [this.propItem.file]
      }
      if (this.propItem.resourceName) {
        this.resourceName = this.propItem.resourceName
      }
      if (this.propItem.resourceSize) {
        this.globalLogger('mounted, resourceSize ', this.propItem.resourceSize)
        this.resourceSize = this.propItem.resourceSize
      }
      switch (this.propItem.type) {
        case 'airquality':
          this.duration = this.propItem.airQualityDuration
          this.pollutionType = this.propItem.pollutionType
          this.imageUrl = this.propItem.imageUrl
          break
        case 'rates':
          this.duration = this.propItem.ratesDuration
          this.ratesSource = this.propItem.ratesSource
          this.imageUrl = this.propItem.imageUrl
          break
        case 'clock':
          this.duration = this.propItem.duration
          this.imageUrl = this.propItem.imageUrl
          break
        case 'arrivals':
          this.duration = this.propItem.duration
          this.airportCode = this.propItem.code
          this.imageUrl = this.propItem.imageUrl
          break
        case 'departures':
          this.duration = this.propItem.duration
          this.airportCode = this.propItem.code
          this.imageUrl = this.propItem.imageUrl
          break
        case 'image':
          this.duration = this.propItem.imageDuration
          this.imageUrl = this.propItem.imageUrl
          break
        case 'url':
          this.url = this.propItem.url
          this.duration = this.propItem.urlDuration
          break
        case 'youtube':
          this.url = this.propItem.youtubeUrl
          break
        case 'weather':
          this.globalLogger('weather')
          this.weatherCity = this.propItem.cityID
          this.duration = this.propItem.weatherDuration
          this.apiKey = this.$store.state.weatherApiKey || ''
          this.imageUrl = this.propItem.imageUrl
          this.globalLogger(this.propItem.imageUrl)
          break
        case 'pdf':
          this.duration = this.propItem.pdfDuration
          this.pdfUrl = this.propItem.pdfUrl
          break
        case 'video':
          this.videoUrl = this.propItem.videoUrl
      }
      this.globalLogger(this.imageUrl, 'imageUrl')
    }
  },
  computed: {
    pollutionTypes () {
      return this.$store.state.pollutionTypes
    },
    weatherCities () {
      return this.$store.state.weatherCities
    },
    role () {
      return this.$store.state.role
    }
  },
  methods: {
    openImageLibrary () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: PhotosLibrary,
          props: { propParent: this.getFileFromChild },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    openVideoLibrary () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: VideosLibrary,
          props: { propParent: this.getFileFromChild },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    openPdfLibrary () {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: PdfsLibrary,
          props: { propParent: this.getFileFromChild },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    },
    getFileFromChild (file) {
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      this.itemFiles = [file]
    },
    getFileFromChildBin (file) {
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      this.itemFiles = [file]
      this.sizeMinus = file.size
      this.deleteFromBinItem = file.name
      this.globalLogger('del from bin playlist: ', this.deleteFromBinItem)
    },
    addFile () {
      if (this.role !== 'viewer') {
        document.getElementById('fileSelect').click()
      }
    },
    fileUploaded (e) {
      this.globalLogger('file uploaded')
      if (this.alreadyUploadedFile !== null) {
        this.newUpload = true
      }
      let files = e.target.files
      this.bFileError = false
      this.itemFiles = [files[0]]
      this.globalLogger('item files', this.itemFiles)
    },
    submitItem () {
      if (this.role !== 'viewer') {
        this.bNameError = false
        this.bFileError = false
        this.bURLError = false
        if (this.name === '') {
          this.bNameError = true
        } else if (this.itemFiles.length === 0 && this.resourceName === '' && (this.type === 'image' || this.type === 'video' || this.type === 'pdf')) {
          this.bFileError = true
          if (this.type === 'image') {
            this.bFileMessage = 'Please upload an image.'
          } else if (this.type === 'video') {
            this.bFileMessage = 'Please upload a video.'
          } else {
            this.bFileMessage = 'Please upload a PDF.'
          }
        } else if (this.url === '' && (this.type === 'url' || this.type === 'youtube')) {
          this.bURLError = true
        } else if (this.type === 'video' && this.itemFiles[0] && this.itemFiles[0].type !== 'video/mp4' && this.itemFiles[0].type !== 'video/avi' && this.itemFiles[0].type !== 'video/x-matroska' && this.itemFiles[0].type !== 'video/quicktime') {
          // if (this.itemFiles[0].type !== 'video/mp4' && this.itemFiles[0].type !== 'video/avi' && this.itemFiles[0].type !== 'video/x-matroska' && this.itemFiles[0].type !== 'video/quicktime') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! The supported types are .mov/.mp4/.mkv/.avi.'
          this.itemFiles = []
        } else if (this.type === 'video' && this.itemFiles[0] && this.itemFiles[0].size >= 157286400) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum video size is 150 MB.'
          this.itemFiles = []
        } else if (this.type === 'image' && this.itemFiles[0] && this.itemFiles[0].type !== 'image/jpeg' && this.itemFiles[0].type !== 'image/png') {
          // if (this.itemFiles[0].type !== 'image/jpeg' && this.itemFiles[0].type !== 'image/png') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! The supported types are .png/.jpg.'
          this.itemFiles = []
        } else if (this.type === 'image' && this.itemFiles[0] && this.itemFiles[0].size >= 5242880) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum image size is 5 MB.'
          this.itemFiles = []
        } else if (this.type === 'pdf' && this.itemFiles[0] && this.itemFiles[0].type !== 'application/pdf') {
          this.bFileError = true
          this.bFileMessage = 'Incompatible file format! Please upload a PDF file.'
          this.itemFiles = []
        } else if (this.type === 'pdf' && this.itemFiles[0] && this.itemFiles[0].size >= 5242880) {
          this.bFileError = true
          this.bFileMessage = 'Resource too big! Maximum PDF file size is 5 MB.'
          this.itemFiles = []
        } else {
          if ((this.itemFiles[0] !== undefined && this.alreadyUploadedFile !== null && this.alreadyUploadedFile[0] !== undefined && this.resourceName !== '' && this.alreadyUploadedFile[0] !== this.itemFiles[0] && !this.newUpload) || (this.itemFiles[0] !== undefined && this.resourceName !== '' && this.alreadyUploadedFile === null)) {
            var isUsed = false
            var brojac = 0
            this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(this.propId) })
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].resourceName === this.resourceName) {
                this.globalLogger('is used is true')
                brojac++
                isUsed = true
              }
            }
            if (isUsed) {
              var mess = null
              if (brojac > 1) {
                mess = 'The previous resource ("' + this.resourceName + '") is also used by other items and will remain in the playlist.'
                // this.$buefy.dialog.alert('The resource "' + fileN + '" is being used by other items and will remain in the playlist.')
              } else {
                mess = 'The previous resource ("' + this.resourceName + '") is also used by another item and will remain in the playlist.'
              }
              this.$buefy.toast.open({
                duration: 8000,
                message: mess
              })
              let item = {
                name: this.name,
                description: this.description,
                type: this.type,
                downloaded: false,
                effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                resourceName: this.resourceName,
                // resourceSize: this.itemFiles[0].size,
                userId: this.$store.state.uid
              }
              if (this.itemFiles[0]) {
                this.globalLogger('this.itemFIles[0] is true')
                item.file = this.itemFiles[0]
                item.resourceSize = this.itemFiles[0].size
                this.sizeOfResource = this.itemFiles[0].size
                this.nameOfResource = this.itemFiles[0].name
              } else if (this.propItem) {
                if (this.propItem.resourceSize) {
                  item.resourceSize = this.propItem.resourceSize
                  this.globalLogger('resSize', this.propItem.resourceSize)
                }
              }
              let dur = parseInt(this.duration)
              switch (this.type) {
                case 'airquality':
                  item.airQualityDuration = dur
                  item.numberOfStations = 5
                  item.pollutionType = this.pollutionType
                  item.imageUrl = ''
                  break
                case 'rates':
                  item.ratesDuration = dur
                  item.ratesSource = this.ratesSource
                  item.imageUrl = ''
                  break
                case 'clock':
                  item.duration = dur
                  item.imageUrl = ''
                  break
                case 'arrivals':
                case 'departures':
                  item.code = this.airportCode
                  item.duration = dur
                  this.globalLogger('code', item.code)
                  this.globalLogger('dur', item.duration)
                  item.imageUrl = ''
                  break
                case 'image':
                  item.imageDuration = dur
                  item.imageUrl = ''
                  break
                case 'weather':
                  item.apiKey = this.$store.state.weatherApiKey || ''
                  item.cityID = this.weatherCity
                  item.weatherDuration = dur
                  item.weatherImageUrl = ''
                  item.imageUrl = ''
                  break
                case 'video':
                  item.videoUrl = ''
                  break
                case 'pdf':
                  item.pdfDuration = dur
                  item.pdfUrl = ''
                  break
              }
              if (this.propItem) {
                switch (this.type) {
                  case 'video':
                    item.videoUrl = this.propItem.videoUrl
                    break
                  case 'weather':
                    item.weatherImageUrl = ''
                    item.imageUrl = this.propItem.imageUrl
                    break
                  case 'image':
                    item.imageUrl = this.propItem.imageUrl
                    this.globalLogger('Image: ', item.imageUrl)
                    break
                  case 'pdf':
                    item.pdfUrl = this.propItem.pdfUrl
                    this.globalLogger('Pdf: ', item.pdfUrl)
                    break
                  case 'airquality':
                  case 'rates':
                  case 'clock':
                  case 'arrivals':
                  case 'departures':
                    if (this.removingBcg) {
                      item.imageUrl = ''
                      this.globalLogger('removing bcg in submit1')
                    } else {
                      item.imageUrl = this.propItem.imageUrl
                      this.globalLogger('Image: ', item.imageUrl)
                    }
                }
                if (!item.imageUrl) {
                  item.imageUrl = ''
                }
                if (!item.videoUrl) {
                  item.videoUrl = ''
                }
                if (!item.pdfUrl) {
                  item.pdfUrl = ''
                }
                this.globalLogger('1', this.oldItem)
                this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.resourceSize, this.resourceName)
              } else {
                this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
              }
              this.$parent.close()
            } else {
              this.$buefy.dialog.confirm({
                message: 'Do you want to delete the previous resource ("' + this.resourceName + '")?',
                cancelText: 'Archive resource',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  this.globalLogger('delete resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be deleted on submit.'
                  })
                  this.toRemove.push(this.resourceName)
                  let item = {
                    name: this.name,
                    description: this.description,
                    type: this.type,
                    downloaded: false,
                    effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                    this.sizeOfResource = this.itemFiles[0].size
                    this.nameOfResource = this.itemFiles[0].name
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      item.resourceSize = this.propItem.resourceSize
                      this.globalLogger('resSize', this.propItem.resourceSize)
                    }
                  }
                  let dur = parseInt(this.duration)
                  switch (this.type) {
                    case 'airquality':
                      item.airQualityDuration = dur
                      item.numberOfStations = 5
                      item.pollutionType = this.pollutionType
                      item.imageUrl = ''
                      break
                    case 'rates':
                      item.ratesDuration = dur
                      item.ratesSource = this.ratesSource
                      item.imageUrl = ''
                      break
                    case 'clock':
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'arrivals':
                    case 'departures':
                      item.code = this.airportCode
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'image':
                      item.imageDuration = dur
                      item.imageUrl = ''
                      break
                    case 'weather':
                      item.apiKey = this.$store.state.weatherApiKey || ''
                      item.cityID = this.weatherCity
                      item.weatherDuration = dur
                      item.weatherImageUrl = ''
                      item.imageUrl = ''
                      break
                    case 'video':
                      item.videoUrl = ''
                      break
                    case 'pdf':
                      item.pdfDuration = dur
                      item.pdfUrl = ''
                      break
                  }
                  if (this.propItem) {
                    switch (this.type) {
                      case 'video':
                        item.videoUrl = this.propItem.videoUrl
                        break
                      case 'weather':
                        item.weatherImageUrl = ''
                        item.imageUrl = this.propItem.imageUrl
                        break
                      case 'image':
                        item.imageUrl = this.propItem.imageUrl
                        this.globalLogger('Image: ', item.imageUrl)
                        break
                      case 'pdf':
                        item.pdfUrl = this.propItem.pdfUrl
                        this.globalLogger('Pdf: ', item.pdfUrl)
                        break
                      case 'airquality':
                      case 'rates':
                      case 'clock':
                      case 'arrivals':
                      case 'departures':
                        if (this.removingBcg) {
                          item.imageUrl = ''
                          this.globalLogger('removing bcg in submit2')
                        } else {
                          item.imageUrl = this.propItem.imageUrl
                          this.globalLogger('Image: ', item.imageUrl)
                        }
                    }
                    if (!item.imageUrl) {
                      item.imageUrl = ''
                    }
                    if (!item.videoUrl) {
                      item.videoUrl = ''
                    }
                    if (!item.pdfUrl) {
                      item.pdfUrl = ''
                    }
                    this.globalLogger('2', this.oldItem)
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource, this.resourceSize, this.resourceName)
                  } else {
                    this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                  }
                  this.$parent.close()
                },
                onCancel: () => {
                  this.globalLogger('archive resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be archived on submit.'
                  })
                  this.toArchive.push({ 'resName': this.resourceName, 'resSize': this.resourceSize })
                  let item = {
                    name: this.name,
                    description: this.description,
                    type: this.type,
                    downloaded: false,
                    effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                    this.sizeOfResource = this.itemFiles[0].size
                    this.nameOfResource = this.itemFiles[0].name
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      item.resourceSize = this.propItem.resourceSize
                      this.globalLogger('resSize', this.propItem.resourceSize)
                    }
                  }
                  let dur = parseInt(this.duration)
                  switch (this.type) {
                    case 'airquality':
                      item.airQualityDuration = dur
                      item.numberOfStations = 5
                      item.pollutionType = this.pollutionType
                      item.imageUrl = ''
                      break
                    case 'rates':
                      item.ratesDuration = dur
                      item.ratesSource = this.ratesSource
                      item.imageUrl = ''
                      break
                    case 'clock':
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'arrivals':
                    case 'departures':
                      item.code = this.airportCode
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'image':
                      item.imageDuration = dur
                      item.imageUrl = ''
                      break
                    case 'weather':
                      item.apiKey = this.$store.state.weatherApiKey || ''
                      item.cityID = this.weatherCity
                      item.weatherDuration = dur
                      item.weatherImageUrl = ''
                      item.imageUrl = ''
                      break
                    case 'video':
                      item.videoUrl = ''
                      break
                    case 'pdf':
                      item.pdfDuration = dur
                      item.pdfUrl = ''
                      break
                  }
                  if (this.propItem) {
                    switch (this.type) {
                      case 'video':
                        item.videoUrl = this.propItem.videoUrl
                        break
                      case 'weather':
                        /* if (this.propItem.weatherImageUrl) {
                          item.weatherImageUrl = this.propItem.weatherImageUrl || ''
                        } else if (this.propItem.imageUrl) {
                          item.weatherImageUrl = this.propItem.imageUrl
                        } */
                        item.weatherImageUrl = ''
                        item.imageUrl = this.propItem.imageUrl
                        break
                      case 'image':
                        item.imageUrl = this.propItem.imageUrl
                        this.globalLogger('Image: ', item.imageUrl)
                        break
                      case 'pdf':
                        item.pdfUrl = this.propItem.pdfUrl
                        this.globalLogger('P df: ', item.pdfUrl)
                        break
                      case 'airquality':
                      case 'rates':
                      case 'clock':
                      case 'arrivals':
                      case 'departures':
                        if (this.removingBcg) {
                          item.imageUrl = ''
                          this.globalLogger('removing bcg in submit3')
                        } else {
                          item.imageUrl = this.propItem.imageUrl
                          this.globalLogger('Image: ', item.imageUrl)
                        }
                        // || this.propItem.weatherImageUrl
                    }
                    if (!item.imageUrl) {
                      item.imageUrl = ''
                    }
                    if (!item.videoUrl) {
                      item.videoUrl = ''
                    }
                    if (!item.pdfUrl) {
                      item.pdfUrl = ''
                    }
                    this.globalLogger('3', this.oldItem)
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                  } else {
                    this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
                  }
                  this.$parent.close()
                }
              })
            }
          } else if (this.removingBcg === true) {
            if (this.bcgIsUsed) {
              this.globalLogger('this.bcgIsUsed is true')
              this.$buefy.toast.open({
                duration: 3000,
                message: 'The previous resource ("' + this.oldBcgResName + '") is being used by another item and will remain in the playlist.'
              })
              let item = {
                name: this.name,
                description: this.description,
                type: this.type,
                downloaded: false,
                effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                resourceName: this.resourceName,
                // resourceSize: this.itemFiles[0].size,
                userId: this.$store.state.uid
              }
              if (this.itemFiles[0]) {
                item.file = this.itemFiles[0]
                item.resourceSize = this.itemFiles[0].size
              } else if (this.propItem) {
                this.globalLogger('tuKA2')
                if (this.propItem.resourceSize) {
                  item.resourceSize = this.propItem.resourceSize
                  this.globalLogger('resSize', this.propItem.resourceSize)
                }
              }
              let dur = parseInt(this.duration)
              switch (this.type) {
                case 'airquality':
                  item.airQualityDuration = dur
                  item.numberOfStations = 5
                  item.pollutionType = this.pollutionType
                  item.imageUrl = ''
                  break
                case 'rates':
                  item.ratesDuration = dur
                  item.ratesSource = this.ratesSource
                  item.imageUrl = ''
                  break
                case 'clock':
                  item.duration = dur
                  item.imageUrl = ''
                  break
                case 'arrivals':
                case 'departures':
                  item.code = this.airportCode
                  item.duration = dur
                  item.imageUrl = ''
                  break
                case 'image':
                  item.imageDuration = dur
                  item.imageUrl = ''
                  break
                case 'weather':
                  item.apiKey = this.$store.state.weatherApiKey || ''
                  item.cityID = this.weatherCity
                  item.weatherDuration = dur
                  item.weatherImageUrl = ''
                  item.imageUrl = ''
                  break
                case 'video':
                  item.videoUrl = ''
                  break
                case 'pdf':
                  item.pdfDuration = dur
                  item.pdfUrl = ''
                  break
              }
              if (this.propItem) {
                switch (this.type) {
                  case 'video':
                    item.videoUrl = this.propItem.videoUrl
                    break
                  case 'weather':
                    item.weatherImageUrl = ''
                    item.imageUrl = this.propItem.imageUrl
                    break
                  case 'image':
                    item.imageUrl = this.propItem.imageUrl
                    this.globalLogger('Image: ', item.imageUrl)
                    break
                  case 'pdf':
                    item.pdfUrl = this.propItem.pdfUrl
                    this.globalLogger('pdf: ', item.pdfUrl)
                    break
                  case 'airquality':
                  case 'rates':
                  case 'clock':
                  case 'arrivals':
                  case 'departures':
                    if (this.removingBcg) {
                      item.imageUrl = ''
                      this.globalLogger('removing bcg in submit+')
                    } else {
                      item.imageUrl = this.propItem.imageUrl
                      this.globalLogger('Image: ', item.imageUrl)
                    }
                }
                if (!item.imageUrl) {
                  item.imageUrl = ''
                }
                if (!item.videoUrl) {
                  item.videoUrl = ''
                }
                if (!item.pdfUrl) {
                  item.pdfUrl = ''
                }
                this.globalLogger('4', this.oldItem)
                this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem)
              } else {
                this.propParentFn(item, this.deleteFromBinItem)
              }
              this.$parent.close()
            } else {
              this.$buefy.dialog.confirm({
                message: 'Do you want to delete the previous resource ("' + this.oldBcgResName + '")?',
                cancelText: 'Archive resource',
                confirmText: 'Delete forever',
                type: 'is-danger',
                onConfirm: () => {
                  this.globalLogger('delete resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be deleted on submit.'
                  })
                  this.globalLogger('old bcg res name in delete: ', this.oldBcgResName)
                  this.toRemove.push(this.oldBcgResName)
                  let item = {
                    name: this.name,
                    description: this.description,
                    type: this.type,
                    downloaded: false,
                    effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                    this.globalLogger('hh1')
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      this.globalLogger('hh2')
                      item.resourceSize = this.propItem.resourceSize
                      this.globalLogger('resSize', this.propItem.resourceSize)
                      this.sizeMinus = item.resourceSize
                      this.globalLogger(this.sizeMinus, 'sizeMinusss!')
                    }
                  }
                  let dur = parseInt(this.duration)
                  switch (this.type) {
                    case 'airquality':
                      item.airQualityDuration = dur
                      item.numberOfStations = 5
                      item.pollutionType = this.pollutionType
                      item.imageUrl = ''
                      break
                    case 'rates':
                      item.ratesDuration = dur
                      item.ratesSource = this.ratesSource
                      item.imageUrl = ''
                      break
                    case 'clock':
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'arrivals':
                    case 'departures':
                      item.code = this.airportCode
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'image':
                      item.imageDuration = dur
                      item.imageUrl = ''
                      break
                    case 'weather':
                      item.apiKey = this.$store.state.weatherApiKey || ''
                      item.cityID = this.weatherCity
                      item.weatherDuration = dur
                      item.weatherImageUrl = ''
                      item.imageUrl = ''
                      break
                    case 'video':
                      item.videoUrl = ''
                      break
                    case 'pdf':
                      item.pdfDuration = dur
                      item.pdfUrl = ''
                      break
                  }
                  if (this.propItem) {
                    switch (this.type) {
                      case 'video':
                        item.videoUrl = this.propItem.videoUrl
                        break
                      case 'weather':
                        item.weatherImageUrl = ''
                        item.imageUrl = this.propItem.imageUrl
                        break
                      case 'image':
                        item.imageUrl = this.propItem.imageUrl
                        this.globalLogger('Image: ', item.imageUrl)
                        break
                      case 'pdf':
                        item.pdfUrl = this.propItem.pdfUrl
                        this.globalLogger('pdff: ', item.pdfUrl)
                        break
                      case 'airquality':
                      case 'rates':
                      case 'clock':
                      case 'arrivals':
                      case 'departures':
                        if (this.removingBcg) {
                          item.imageUrl = ''
                          this.globalLogger('removing bcg in submit++')
                        } else {
                          item.imageUrl = this.propItem.imageUrl
                          this.globalLogger('Image: ', item.imageUrl)
                        }
                    }
                    if (!item.imageUrl) {
                      item.imageUrl = ''
                    }
                    if (!item.videoUrl) {
                      item.videoUrl = ''
                    }
                    if (!item.pdfUrl) {
                      item.pdfUrl = ''
                    }
                    this.globalLogger('here10')
                    this.globalLogger('5', this.oldItem)
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, undefined, undefined, undefined, undefined, this.sizeMinus)
                  } else {
                    this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource, this.sizeMinus)
                  }
                  this.$parent.close()
                },
                onCancel: () => {
                  this.globalLogger('archive resource')
                  this.$buefy.toast.open({
                    duration: 3000,
                    message: 'The previous resource will be archived on submit.'
                  })
                  this.toArchive.push({ 'resName': this.oldBcgResName, 'resSize': this.oldBckResSize })
                  let item = {
                    name: this.name,
                    description: this.description,
                    type: this.type,
                    downloaded: false,
                    effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
                    resourceName: this.resourceName,
                    userId: this.$store.state.uid
                  }
                  if (this.itemFiles[0]) {
                    item.file = this.itemFiles[0]
                    item.resourceSize = this.itemFiles[0].size
                  } else if (this.propItem) {
                    if (this.propItem.resourceSize) {
                      item.resourceSize = this.propItem.resourceSize
                      this.sizeMinus = 0
                      this.globalLogger('resSize', this.propItem.resourceSize)
                    }
                  }
                  let dur = parseInt(this.duration)
                  switch (this.type) {
                    case 'airquality':
                      item.airQualityDuration = dur
                      item.numberOfStations = 5
                      item.pollutionType = this.pollutionType
                      item.imageUrl = ''
                      break
                    case 'rates':
                      item.ratesDuration = dur
                      item.ratesSource = this.ratesSource
                      item.imageUrl = ''
                      break
                    case 'clock':
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'arrivals':
                    case 'departures':
                      item.code = this.airportCode
                      item.duration = dur
                      item.imageUrl = ''
                      break
                    case 'image':
                      item.imageDuration = dur
                      item.imageUrl = ''
                      break
                    case 'weather':
                      item.apiKey = this.$store.state.weatherApiKey || ''
                      item.cityID = this.weatherCity
                      item.weatherDuration = dur
                      item.weatherImageUrl = ''
                      item.imageUrl = ''
                      break
                    case 'video':
                      item.videoUrl = ''
                      break
                    case 'pdf':
                      item.pdfDuration = dur
                      item.pdfUrl = ''
                      break
                  }
                  if (this.propItem) {
                    switch (this.type) {
                      case 'video':
                        item.videoUrl = this.propItem.videoUrl
                        break
                      case 'weather':
                        /* if (this.propItem.weatherImageUrl) {
                          item.weatherImageUrl = this.propItem.weatherImageUrl || ''
                        } else if (this.propItem.imageUrl) {
                          item.weatherImageUrl = this.propItem.imageUrl
                        } */
                        item.weatherImageUrl = ''
                        item.imageUrl = this.propItem.imageUrl
                        break
                      case 'image':
                        item.imageUrl = this.propItem.imageUrl
                        this.globalLogger('Image: ', item.imageUrl)
                        break
                      case 'pdf':
                        item.pdfUrl = this.propItem.pdfUrl
                        this.globalLogger('pdf!: ', item.pdfUrl)
                        break
                      case 'airquality':
                      case 'rates':
                      case 'clock':
                      case 'arrivals':
                      case 'departures':
                        if (this.removingBcg) {
                          item.imageUrl = ''
                          this.globalLogger('removing bcg in submit3')
                        } else {
                          item.imageUrl = this.propItem.imageUrl
                          this.globalLogger('Image: ', item.imageUrl)
                        }
                        // || this.propItem.weatherImageUrl
                    }
                    if (!item.imageUrl) {
                      item.imageUrl = ''
                    }
                    if (!item.videoUrl) {
                      item.videoUrl = ''
                    }
                    if (!item.pdfUrl) {
                      item.pdfUrl = ''
                    }
                    this.globalLogger('6', this.oldItem)
                    this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, undefined, undefined, undefined, undefined, this.sizeMinus)
                  } else {
                    this.propParentFn(item, this.deleteFromBinItem)
                  }
                  this.$parent.close()
                }
              })
            }
          } else {
            this.globalLogger('this.removing background ne e true')
            let item = {
              name: this.name,
              description: this.description,
              type: this.type,
              downloaded: false,
              effect: (parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect),
              resourceName: this.resourceName,
              userId: this.$store.state.uid
            }
            if (this.itemFiles[0]) {
              // this.globalLogger('tuka sum', this.itemFiles[0])
              item.file = this.itemFiles[0]
              item.resourceSize = this.itemFiles[0].size
              this.sizeOfResource = this.itemFiles[0].size
              this.nameOfResource = this.itemFiles[0].name
              this.globalLogger(this.sizeOfResource, 'SIZE OF RESOURCe')
            } else if (this.propItem) {
              if (this.propItem.resourceSize) {
                item.resourceSize = this.propItem.resourceSize
                this.globalLogger('resSize', this.propItem.resourceSize)
              }
            }
            let dur = parseInt(this.duration)
            switch (this.type) {
              case 'airquality':
                item.airQualityDuration = dur
                item.numberOfStations = 5
                item.pollutionType = this.pollutionType
                item.imageUrl = ''
                break
              case 'rates':
                item.ratesDuration = dur
                item.ratesSource = this.ratesSource
                item.imageUrl = ''
                break
              case 'clock':
                item.duration = dur
                item.imageUrl = ''
                break
              case 'arrivals':
              case 'departures':
                item.code = this.airportCode
                item.duration = dur
                item.imageUrl = ''
                break
              case 'image':
                item.imageDuration = dur
                item.imageUrl = ''
                break
              case 'url':
                item.urlDuration = dur
                item.url = this.url
                break
              case 'weather':
                item.apiKey = this.$store.state.weatherApiKey || ''
                item.cityID = this.weatherCity
                item.weatherDuration = dur
                item.weatherImageUrl = ''
                item.imageUrl = ''
                break
              case 'video':
                item.videoUrl = ''
                break
              case 'youtube':
                item.youtubeUrl = this.url
                break
              case 'pdf':
                item.pdfDuration = dur
                item.pdfUrl = ''
                break
            }
            if (this.propItem) {
              switch (this.type) {
                case 'video':
                  item.videoUrl = this.propItem.videoUrl
                  break
                case 'weather':
                  item.weatherImageUrl = ''
                  item.imageUrl = this.propItem.imageUrl
                  break
                case 'image':
                  item.imageUrl = this.propItem.imageUrl
                  this.globalLogger('Image: ', item.imageUrl)
                  break
                case 'pdf':
                  item.pdfUrl = this.propItem.pdfUrl
                  this.globalLogger('pdf: ', item.pdfUrl)
                  break
                case 'airquality':
                case 'rates':
                case 'clock':
                case 'arrivals':
                case 'departures':
                  if (this.removingBcg) {
                    item.imageUrl = ''
                    this.globalLogger('removing bcg in submit4')
                  } else {
                    item.imageUrl = this.propItem.imageUrl
                    this.globalLogger('Image: ', item.imageUrl)
                  }
              }
              if (!item.imageUrl) {
                this.globalLogger('!item.imageUrl')
                item.imageUrl = ''
              }
              if (!item.videoUrl) {
                item.videoUrl = ''
              }
              if (!item.pdfUrl) {
                item.pdfUrl = ''
              }
              this.globalLogger('ovde')
              this.globalLogger('7', this.oldItem)
              this.propParentFn(item, this.oldItem, this.propId, this.toRemove, this.toArchive, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource)
            } else {
              this.propParentFn(item, this.deleteFromBinItem, this.sizeOfResource, this.nameOfResource, this.sizeMinus)
            }
            this.$parent.close()
          }
        }
      }
    },
    getButtonText () {
      switch (this.type) {
        case 'video':
          return 'Choose video file'
        case 'image':
          return 'Choose image file'
        case 'pdf':
          return 'Choose PDF file'
        default:
          return 'Choose background image'
      }
    },
    debugEffectLog () {
      this.globalLogger((parseInt(this.entryEffect) * 10) + parseInt(this.exitEffect))
    },
    removeBackgroundImage () {
      if (this.role !== 'viewer') {
        this.$buefy.dialog.confirm({
          message: 'Do you want to remove the resource from the item?',
          cancelText: 'No',
          confirmText: 'Yes',
          type: 'is-danger',
          onConfirm: () => {
            this.items = this.items.filter((x) => { return this.items.indexOf(x) !== parseInt(this.propId) })
            for (let i = 0; i < this.items.length; i++) {
              if (this.items[i].resourceName === this.resourceName) {
                this.globalLogger('is used is true')
                this.bcgIsUsed = true
              }
            }
            this.oldBcgResName = this.resourceName
            this.oldBckResSize = this.resourceSize
            this.resourceName = ''
            this.imageUrl = null
            this.removingBcg = true
          }
        })
      }
    },
    openBin (type) {
      if (this.role !== 'viewer') {
        this.$buefy.modal.open({
          parent: this,
          component: PlaylistsBin,
          props: { propParent: this.getFileFromChildBin, type: type },
          hasModalCard: true,
          trapFocus: true,
          onCancel: this.cancelAdd,
          canCancel: ['x']
        })
      }
    }
  }
}
</script>

<style scoped>
.__cov-video {
    width: 65%;
    height: 65%;
    vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/playlists/items/ItemAddEdit.vue